import { render, staticRenderFns } from "./DustRemovalSelect.vue?vue&type=template&id=6e8618d1&"
import script from "./DustRemovalSelect.vue?vue&type=script&lang=js&"
export * from "./DustRemovalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports